import { render, staticRenderFns } from "./fault-detail.vue?vue&type=template&id=b881c8d8&scoped=true&"
import script from "./fault-detail.vue?vue&type=script&lang=js&"
export * from "./fault-detail.vue?vue&type=script&lang=js&"
import style0 from "./fault-detail.vue?vue&type=style&index=0&id=b881c8d8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b881c8d8",
  null
  
)

export default component.exports